import { WModalButton, type WModalButtonProps } from "@/components/button/WToolButton.tsx";
import { WModal, WModalContent } from "@/components/modal/WModal.tsx";
import { useStandardMutation } from "@/modules/api/useStandardMutation.ts";
import { acceptInvitationMutation } from "@/modules/user/userApi.ts";
import { Trans, useLingui } from "@lingui/react/macro";

export function AcceptInvitationModal({
    uuid,
    name,
    buttonProps,
}: {
    uuid: string;
    name: string;
    buttonProps?: Omit<WModalButtonProps, "label" | "icon">;
}) {
    const { t } = useLingui();
    const acceptMutation = useStandardMutation(acceptInvitationMutation);

    async function acceptInvitation() {
        await acceptMutation.mutateAsync({ uuid });
    }

    return (
        <WModal
            button={
                <WModalButton
                    inTable
                    showLabel
                    color="success"
                    label={t`Accept`}
                    icon="i-lucide:user-round-check"
                    {...buttonProps}
                />
            }
        >
            <WModalContent title={t`Accept invitation`} label={t`Accept`} modalAction={acceptInvitation}>
                <p className="pb-4">
                    <Trans>
                        Accepting this access invitation will grant you permission to act as "{name}" and perform all
                        operations on behalf of the user.
                    </Trans>
                </p>
                <p>
                    <Trans>
                        Note! The owner will know if you have accepted this invitation. They will not be able to access
                        your user account and see or edit any of your resources.
                    </Trans>
                </p>
            </WModalContent>
        </WModal>
    );
}
